import React from 'react';
import { CurrentIssuesPage } from './CurrentIssuesPage';

export function Issues() {
  return <CurrentIssuesPage />;
}
